













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Course, ExperimentGetter } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';

@Component({
  components: { BriocheBackgroundImage },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
    ...mapGetters('globals', ['inExperiment']),
  },
})
export default class CoverDescriptions extends Vue {
  @Prop({ type: Object, required: true })
  private course!: Course;
  @Prop({ type: Number, required: true })
  private lessons!: number;
  @Prop({ type: Boolean, required: true })
  private hasPractice!: boolean;

  private readonly learningPath?: RelatedLearningPathInfo;
  private readonly inExperiment!: ExperimentGetter;

  private get isInLLPNuxRecsExperiment(): boolean {
    return !!this.learningPath && this.inExperiment('um_llp_nux_recs_05_2023', 'experiment');
  }
}
